import moment from 'moment-timezone';

const hasShownUp = (section, now) =>
	!section.appears_at || !moment(section.appears_at).isAfter(now);
const isCurrent = (section, now) =>
	!section.current_until || moment(now).isBefore(section.current_until);
const byStart = (a, b) => moment(a.appears_at).diff(moment(b.appears_at));

// Mirrors the backend visibility rules without groups, since the builder has no attendee.
export const previewModel = (content, show, now) => {
	const sections = (content?.sections ?? []).filter(section => section.items.length > 0);
	const shownUp = sections.filter(section => hasShownUp(section, now));
	const upcoming = sections.filter(section => !hasShownUp(section, now)).sort(byStart);
	const current = shownUp.filter(section => isCurrent(section, now));
	const all = show === 'all';
	// Show all keeps upcoming sections in place so admins see where they'll appear.
	const shown = (all ? sections : current).map(section => {
		const upcoming = !hasShownUp(section, now);
		return { ...section, upcoming, collapsed: upcoming || !isCurrent(section, now) };
	});

	const state = !sections.length
		? 'empty'
		: !shownUp.length
		? 'hidden'
		: !all && !current.length
		? 'caughtUp'
		: 'list';

	return {
		state,
		currentTotal: current.reduce((sum, section) => sum + section.items.length, 0),
		sections: shown,
		next: upcoming[0] ?? null,
	};
};
